export default __webpack_public_path__ + "static/media/star.765128c3.png";